// src/store/rootReducer.js
import { combineReducers } from 'redux';
import theme from './slices/themeSlice';
import auth from './slices/authSlice';
import users from './slices/usersSlice'; // ← nuevo
import empleados from './slices/empleadosSlice'; // ← nuevo
import empresas from './slices/empresasSlice'; // ← nuevo
import geocercas from './slices/geocercasSlice'; // ← nuevo
import configuracion from './slices/configuracionSlice'; // ← nuevo
import asistencias from './slices/asistenciasSlice';
import reportes from './slices/reportesSlice';


const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        users,
        empleados,
        empresas, // ← nuevo
        geocercas, // ← nuevo
        configuracion, // ← nuevo
        asistencias,
        reportes,
        ...asyncReducers,
    });
    return combinedReducer(state, action);
};

export default rootReducer;